import onPageLoad from './onPageLoad'

function initLoadOnScroll() {
  const scrollTarget = document.getElementById('scroll-target')
  const wrapper = document.getElementById('load-on-scroll-wrapper')
  let page = 0
  let isLoading = false
  let isFinished = false
  let isScrollTargetInView = false

  function appendHtml(html) {
    const div = document.createElement('div')
    div.innerHTML = html
    wrapper.appendChild(div)
    onPageLoad(div)
    return div
  }

  function finish() {
    scrollTarget.style.display = 'none'
  }

  async function loadNextPage() {
    isLoading = true
    const res = await fetch(
      `${window.location.pathname}/apartments?page=${page}`
    )
    const text = await res.text()
    page += 1
    const div = appendHtml(text)
    isLoading = false
    return div
  }

  async function loadNextAndFinish() {
    const div = await loadNextPage()
    isFinished = div.querySelectorAll('.apartments-card').length === 0
    if (isFinished) {
      finish()
    } else if (isScrollTargetInView) {
      loadNextAndFinish()
    }
  }

  const callback = async ([entry]) => {
    isScrollTargetInView = entry.isIntersecting
    if (isScrollTargetInView && !isLoading && !isFinished) {
      loadNextAndFinish()
    }
  }
  const observer = new IntersectionObserver(callback, {
    rootMargin: '200px 0px 200px',
  })

  observer.observe(scrollTarget)
}

export default initLoadOnScroll
